(() => {
  const normalize = (value) =>
    String(value || '')
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

  const initDirectory = (root) => {
    if (!root || root.dataset.mfDirectoryReady === 'true') return;

    const search = root.querySelector('[data-mf-directory-search]');
    const clear = root.querySelector('[data-mf-directory-clear]');
    const reset = root.querySelector('[data-mf-directory-reset]');
    const empty = root.querySelector('[data-mf-directory-empty]');
    const status = root.querySelector('[data-mf-directory-status]');
    const filters = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-mf-collection-card]'));
    const secondary = root.querySelector('[data-mf-directory-secondary]');
    let activeFilter = 'all';

    const update = () => {
      const query = normalize(search?.value);
      let visibleCount = 0;
      let secondaryVisible = 0;

      cards.forEach((card) => {
        const keywords = normalize(card.dataset.keywords);
        const category = normalize(card.dataset.category);
        const matchesQuery = !query || keywords.includes(query);
        const matchesFilter = activeFilter === 'all' || category === activeFilter;
        const isVisible = matchesQuery && matchesFilter;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
        if (isVisible && card.closest('[data-mf-directory-secondary]')) secondaryVisible += 1;
      });

      if (clear) clear.hidden = !query;
      if (empty) empty.hidden = visibleCount !== 0;
      if (secondary) secondary.hidden = secondaryVisible === 0;
      if (status) {
        status.textContent = `${visibleCount} collection${visibleCount === 1 ? '' : 's'} shown`;
      }
    };

    const setFilter = (value) => {
      activeFilter = normalize(value) || 'all';
      filters.forEach((button) => {
        const isActive = normalize(button.dataset.filter) === activeFilter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      update();
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => setFilter(button.dataset.filter));
    });

    search?.addEventListener('input', update);
    search?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && search.value) {
        search.value = '';
        update();
      }
    });

    clear?.addEventListener('click', () => {
      if (!search) return;
      search.value = '';
      search.focus();
      update();
    });

    reset?.addEventListener('click', () => {
      if (search) search.value = '';
      setFilter('all');
      search?.focus();
    });

    root.dataset.mfDirectoryReady = 'true';
    update();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-mf-directory]').forEach(initDirectory);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
